import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import _defineProperty from "/var/www/vhosts/voicebrief.app/httpdocs/next/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import IcoMoon from 'react-icomoon';

var iconSet = require('../../assets/icomoon/selection.json');

var BriefIcon = function BriefIcon(props) {
  var icona = /*#__PURE__*/_jsx(IcoMoon, _objectSpread(_objectSpread({
    iconSet: iconSet
  }, props), {}, {
    className: "briefIcon ".concat(props.icon, " ").concat(props.className)
  }));

  if (props.title) {
    return /*#__PURE__*/_jsx(_Tooltip, {
      title: props.title,
      children: icona
    });
  } else {
    return icona;
  }
};

BriefIcon.defaultProps = {
  size: '2em',
  className: '',
  title: ''
};
export default BriefIcon;